exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#store-dialog .el-upload-dragger{height:200px;width:200px}", ""]);

// exports
